/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type InlineCommentsFocusedInlineCommentQuery$variables = {
  commentId: string;
  contentId?: string | null;
};
export type InlineCommentsFocusedInlineCommentQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly isInlineComment: boolean;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly replies: ReadonlyArray<{
          readonly author: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly permissionType: SitePermissionType | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          };
          readonly body: {
            readonly value: string;
          };
          readonly createdAt: {
            readonly value: string;
          };
          readonly createdAtNonLocalized: string;
          readonly id: string;
          readonly isInlineComment: boolean;
          readonly links: {
            readonly editui: string | null;
            readonly webui: string | null;
          };
          readonly permissions: {
            readonly isEditable: boolean;
            readonly isRemovable: boolean;
            readonly isResolvable: boolean;
          };
          readonly version: {
            readonly by: {
              readonly displayName: string | null;
            } | null;
            readonly number: number | null;
            readonly when: string | null;
          };
        } | null>;
        readonly version: {
          readonly by: {
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly author: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly permissionType: SitePermissionType | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      };
      readonly body: {
        readonly value: string;
      };
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly isInlineComment: boolean;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      };
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly isInlineComment: boolean;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly version: {
          readonly by: {
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly number: number | null;
        readonly when: string | null;
      };
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly id: string | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
          readonly targetType: string | null;
        } | null> | null;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type InlineCommentsFocusedInlineCommentQuery = {
  response: InlineCommentsFocusedInlineCommentQuery$data;
  variables: InlineCommentsFocusedInlineCommentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v3 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "contentId"
    }
  ],
  "concreteType": "PaginatedContentListWithChild",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ]
        },
        (v2/*: any*/)
      ]
    }
  ]
},
v4 = [
  {
    "kind": "Variable",
    "name": "commentId",
    "variableName": "commentId"
  },
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ALL"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "UNRESOLVED"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "value"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v8 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v6/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v10 = {
  "kind": "ScalarField",
  "name": "isInlineComment"
},
v11 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v13 = {
  "kind": "ScalarField",
  "name": "when"
},
v14 = {
  "kind": "ScalarField",
  "name": "number"
},
v15 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v12/*: any*/)
      ]
    },
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v17 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v20 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ]
},
v21 = {
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "replies",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v20/*: any*/)
  ]
},
v22 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v12/*: any*/),
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v12/*: any*/)
      ]
    },
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v25 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ]
},
v26 = {
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "replies",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v24/*: any*/),
    (v16/*: any*/),
    (v25/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineCommentsFocusedInlineCommentQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ]
              },
              (v1/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      },
      (v22/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineCommentsFocusedInlineCommentQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v24/*: any*/),
                  (v16/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              },
              (v1/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v24/*: any*/),
              (v16/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      },
      (v22/*: any*/)
    ]
  },
  "params": {
    "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
    "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
    "metadata": {},
    "name": "InlineCommentsFocusedInlineCommentQuery",
    "operationKind": "query",
    "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";

export default node;
